import { render, staticRenderFns } from "./ScoringVotesSourceSelectorDialog.vue?vue&type=template&id=c59f1ed0"
import script from "./ScoringVotesSourceSelectorDialog.vue?vue&type=script&lang=ts"
export * from "./ScoringVotesSourceSelectorDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports